export const CHECKOUT_CONFIRMATION_MY_CALIX_LINK_ID = 'my-calix-link';
export const CHECKOUT_CONFIRMATION_TERMS_LINK_ID = 'terms-of-sale-link';
